import { useQuery } from '@tanstack/react-query'

import { recruiterHiresApi } from '@/features/recruiter/api/hires.api'

export function useRecruiterHiresQuery(params: { q?: string; page?: number; per_page?: number }) {
  return useQuery({
    queryKey: ['recruiter', 'hires', params],
    queryFn: () => recruiterHiresApi.list(params),
    placeholderData: (previous) => previous,
  })
}
